import { render, staticRenderFns } from "./AssetCreateForm.vue?vue&type=template&id=c9c3f778&"
import script from "./AssetCreateForm.vue?vue&type=script&lang=js&"
export * from "./AssetCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports